import { render, staticRenderFns } from "./DraggableContainer.vue?vue&type=template&id=3eaf52f4&scoped=true&"
import script from "./DraggableContainer.vue?vue&type=script&lang=ts&"
export * from "./DraggableContainer.vue?vue&type=script&lang=ts&"
import style0 from "./DraggableContainer.vue?vue&type=style&index=0&id=3eaf52f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eaf52f4",
  null
  
)

export default component.exports